import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

const baseURL = `${baseAPI}/campaign`

export const listKeywordsService = (
  params: RequestGetAdditionalKeywordsServiceParams
) => {
  const { campaignId, count, page, quantity, is_negative } = params
  return axios.get<GetAdditionalKeywordsServiceResponse>(
    `${baseURL}/${campaignId}/additional-keywords`,
    { params: { count, quantity, page, is_negative } }
  )
}

export const changeStatusKeywordService = (params: {
  id: string
  active: boolean
  campaignId: string
}) =>
  axios.patch<CampaignKeyword>(
    `${baseURL}/${params.campaignId}/additional-keywords/${params.id}`,
    {
      active: params.active
    }
  )

export const addKeywordsBulkService = (params: RequestAddKeywordBulkParams) =>
  axios.post<CampaignKeyword[]>(
    `${baseURL}/${params.campaignId}/additional-keywords/bulk${params?.negative ? '/negative' : ''}`,
    { keywords: params.keywords }
  )
